import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";

import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";
export default function ThirdCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Guardar Domingos e Festas"}/>

            <p className="info-text">
            Este mandamento ordena reservar um dia para culto e descanso. Inicialmente tratava-se do sábado judaico, memória da Criação e da libertação do Egito[25]. <br/>
            Deus “abençoou” o sétimo dia após a Criação (Ex 20,11), e ordenou o descanso para todos, sinal da Aliança[25]. <br/>
            Para nós cristãos, o “dia do Senhor” é o Domingo, dia da ressurreição de Cristo[26][27].<br/>
            O Catecismo ensina que o Domingo realiza o sentido espiritual do sábado, sendo “o dia do Senhor” que celebra a Nova Criação em Cristo[26][28]. <br/>
            É o primordial dia festivo cristão[29][30]. <br/>
            O mandamento moral cumpre-se participando da Eucaristia dominical e dando a Deus culto público regular[31][32]. <br/>
            Além disso, somos chamados a repousar de trabalhos injustos e dedicar tempo à família e à oração[33][34]                
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
            Guardar o Domingo significa assistir à missa e abster-se de atividades que prejudiquem a santidade desse dia[31][35].<br/> 
            Na prática, pode-se descansar, conviver com a família, ajudar necessitados e fazer obras de misericórdia (como visitar os doentes ou idosos)[36][34]. <br/>
            Evita-se consumismo excessivo, trabalho desnecessário e entretenimentos que desrespeitem o recolhimento próprio do Dia do Senhor[36][37]. <br/>
            O CIC lembra que, para muitos pobres, o domingo é tempo de lazer e união familiar, e todos devem garantir descanso uns aos outros (patrões concedendo folga, governos assegurando feriados religiosos)[38][39]. <br/>
            Caso a missa não seja acessível, recomenda-se participar de outra celebração litúrgica ou dedicar-se à oração em família[40]
            </p> 

            <Title text={"Aspectos Teológicos"}/>

            <p className="info-text">
                O Domingo é memorial pascal. Ao celebrá-lo, os cristãos proclamam a ressurreição de Cristo e a nova criação que Ele inaugurou[26][27]. <br/>
                A guarda dominical está ligada ao mandamento de amor a Deus e prefigura o descanso eterno junto de Deus[28][27]. <br/>
                Teologicamente, participar da missa dominical une-nos a Cristo Ressuscitado (lembremos que “onde estiver o vosso tesouro, aí estará também o vosso coração”, Mt 6,21[41]). <br/>
                Além do culto divino, o mandamento ensina a dimensão social do repouso: o descanso dominical promove justiça social ao assegurar tempo à família, cultura, lazer e espiritualidade de todos[33][34]
            </p> 

            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}